/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faint_Rich_Wasp_MarchInputs */

const en_faint_rich_wasp_march = /** @type {(inputs: Faint_Rich_Wasp_MarchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All available segments are already added.`)
};

const de_faint_rich_wasp_march = /** @type {(inputs: Faint_Rich_Wasp_MarchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle verfügbaren Segmente sind bereits hinzugefügt.`)
};

/**
* | output |
* | --- |
* | "All available segments are already added." |
*
* @param {Faint_Rich_Wasp_MarchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const faint_rich_wasp_march = /** @type {((inputs?: Faint_Rich_Wasp_MarchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faint_Rich_Wasp_MarchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faint_rich_wasp_march(inputs)
	return de_faint_rich_wasp_march(inputs)
});